import React, { FC, useMemo } from 'react';
import { EntityId } from '@reduxjs/toolkit';
import { DialogPreview, DialogStateShape, dialogModel, useUnreadMessagesCountInDialog } from '@cp/entities/dialog';
import { useSelector } from 'react-redux';
import { MemberUser } from '@youhelp-ru/core';
import { SUPPORT_DIALOG_QUERY } from 'src/entities/supportDialog';

export interface DialogListItemProps {
  currentUser: MemberUser;
  dialogId: EntityId;
  onSelect: (dialogId: number) => void;
}

export const DialogListItem: FC<DialogListItemProps> = ({ dialogId, onSelect, currentUser }) => {
  const currentMemberSelectorParams = useMemo(
    () => ({
      user: currentUser,
      dialogId,
    }),
    [dialogId, currentUser],
  );
  const participant = useSelector<DialogStateShape, ReturnType<typeof dialogModel.selectors.initialParticipantMemberSelector>>((state) =>
    dialogModel.selectors.initialParticipantMemberSelector(state, currentMemberSelectorParams),
  );
  const unreadMessagesCount = useUnreadMessagesCountInDialog(dialogId, SUPPORT_DIALOG_QUERY);
  const lastMessage = useSelector<DialogStateShape, ReturnType<typeof dialogModel.selectors.dialogLastMessageSelector>>((state) =>
    dialogModel.selectors.dialogLastMessageSelector(state, dialogId),
  );

  return participant ? (
    <DialogPreview
      component="li"
      dialogId={dialogId as number}
      key={dialogId}
      message={lastMessage}
      onSelect={onSelect}
      participant={participant}
      unreadMessagesCount={unreadMessagesCount}
    />
  ) : null;
};
